import styled from "styled-components"

export const HeroSection = styled.div`
  position: relative;
  background-color: #000;
  .nav-wrapper {
    border-bottom: 0.1px solid #00000024;
  }
  h1 {
    font-family: "Mont";
    font-size: 45px;
    font-weight: 900;
    color: #fff;
    font-size: 56px;
    letter-spacing: 0.2px;
  }
  p {
    font-size: 18px;
    color: #fff;
    span {
      font-size: 20px;
      font-weight: 600;
      color: #fff;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    height: auto !important;
  }
  @media (min-width: 481px) and (max-width: 767px) {
    height: auto !important;
  }
  @media (min-width: 280px) and (max-width: 480px) {
    height: auto !important;
    h1 {
      font-family: "Mont";
      font-size: 32px !important;
      font-weight: 900;
      color: #fff;
    }
  }
`
